// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M11 4V6H2V20H22V6H13V4H17V2H13C11.8954 2 11 2.89543 11 4ZM9 10V12H11V14H9V16H7V14H5V12H7V10H9ZM15 10H17.0035V12H19.0035V14.004H17.0035V16.004H15V14.004H13V12H15V10ZM15.0035 12.004V14H17V12.004H15.0035Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-gamepad-1-filled')
export default class Gamepad1FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'gamepad-1-filled',
    }
  }
}
